"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wishlist = void 0;
const exceptions_1 = require("../exceptions");
const services_1 = require("../services");
class Wishlist {
    constructor(userId) {
        this.userId = userId;
        this._favourites = [];
    }
    get favourites() {
        return this._favourites;
    }
    get stateHash() {
        const studyStrings = this._favourites.map(favourite => {
            if (favourite.properties && Object.keys(favourite.properties).length > 0) {
                return `${favourite.study.id}|${JSON.stringify(favourite.properties)}`;
            }
            return favourite.study.id;
        });
        return services_1.StateHasher.hash(studyStrings);
    }
    changeOrder(targetStudyId, referenceStudyId) {
        if (targetStudyId === referenceStudyId) {
            throw new exceptions_1.WishlistException('targetStudy cannot be the same study as referenceStudy');
        }
        if (!this.isFavourited(targetStudyId)) {
            throw new exceptions_1.WishlistException('targetStudy does not exist');
        }
        let indexOfReference = -1;
        const targetStudy = this.removeAndRetrieveFavouriteFromFavourites(targetStudyId);
        if (referenceStudyId) {
            if (!this.isFavourited(referenceStudyId)) {
                throw new exceptions_1.WishlistException('referenceStudy does not exist');
            }
            indexOfReference = this.favourites.findIndex((favourite) => favourite.study.id === referenceStudyId);
            // put the targetStudy after the referenceStudy
        }
        this.favourites.splice(indexOfReference + 1, 0, targetStudy);
    }
    removeAndRetrieveFavouriteFromFavourites(targetStudyId) {
        const indexOfTarget = this.favourites.findIndex((favourite) => favourite.study.id === targetStudyId);
        const targetStudy = this.favourites[indexOfTarget];
        this.favourites.splice(indexOfTarget, 1);
        return targetStudy;
    }
    addFavourite(favourite) {
        if (this.containsStudy(favourite.study.id)) {
            throw new exceptions_1.StudyAlreadyFavourited(this.userId, favourite.study.id);
        }
        this._favourites.push(favourite);
    }
    removeFavourite(studyId) {
        this.removeStudyFromFavourites(studyId);
    }
    containsStudy(studyId) {
        return this._favourites.some(f => f.study.id === studyId);
    }
    findFavourite(studyId) {
        return this._favourites.find(favourite => favourite.study.id === studyId) || null;
    }
    removeStudyFromFavourites(studyId) {
        let removed = false;
        this._favourites = this._favourites.filter(f => {
            const matchFound = f.study.id === studyId;
            if (matchFound) {
                removed = true;
            }
            return !matchFound;
        });
        if (!removed) {
            throw new exceptions_1.FavouriteNotFound(this.userId, studyId);
        }
    }
    toJSON() {
        return {
            userId: this.userId,
            favourites: this._favourites
        };
    }
    isFavourited(studyId) {
        return this._favourites.some(favourite => {
            return favourite.study.id === studyId;
        });
    }
}
exports.Wishlist = Wishlist;
